// extracted by mini-css-extract-plugin
module.exports = {"errorMsg":"DiscordRedirected_errorMsg__2z00P"};